import { useHistory } from 'react-router-dom';
import './styles.css'

export function Contato() {
    const history = useHistory();
    const handleNavigateToRegister = () => {
        history.push('/register');
    }
    return (
        <section className="contatoComponent" id="contato">
            <div className="textButtonContact">
                <h2>VOCÊ É PROFISSIONAL DA SAÚDE?</h2>
                <p className="textContact">Registre-se gratuitamente como especialista
                e seja encontrado por pacientes de todo o país!</p>
                <button onClick={handleNavigateToRegister} className="buttonContact">QUERO FAZER PARTE</button>
            </div>
        </section>
    )
}